import React from 'react'
import { Box, Typography, Chip } from '@mui/material'
import { CheckCircle } from 'lucide-react'

function formatNumber(num: number): string {
  if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`
  if (num >= 1000) return `${(num / 1000).toFixed(1)}K`
  return num.toString()
}

interface Props {
  profile: {
    username: string
    fullName: string | null
    biography: string | null
    profilePicUrl: string | null
    followerCount: number
    followingCount: number
    mediaCount: number
    isVerified: boolean
  }
}

export default function ProfileCard({ profile }: Props): JSX.Element {
  return (
    <Box
      sx={{
        backgroundColor: 'rgba(255,255,255,0.03)',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: '16px',
        p: 3,
        mb: 2,
        display: 'flex',
        gap: 2.5,
        alignItems: 'center',
      }}
    >
      {profile.profilePicUrl && (
        <Box
          component="img"
          src={profile.profilePicUrl}
          sx={{ width: 72, height: 72, borderRadius: '50%', objectFit: 'cover', border: '2px solid rgba(168,85,247,0.3)' }}
        />
      )}
      <Box sx={{ flex: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
          <Typography sx={{ color: 'white', fontWeight: 700, fontSize: '18px' }}>
            @{profile.username}
          </Typography>
          {profile.isVerified && <CheckCircle size={16} color="#a855f7" />}
        </Box>
        {profile.fullName && (
          <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '14px', mb: 0.5 }}>
            {profile.fullName}
          </Typography>
        )}
        {profile.biography && (
          <Typography sx={{ color: 'rgba(255,255,255,0.4)', fontSize: '13px', mb: 1.5, lineHeight: 1.4, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
            {profile.biography}
          </Typography>
        )}
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography sx={{ color: 'white', fontWeight: 700, fontSize: '16px' }}>{formatNumber(profile.followerCount)}</Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.4)', fontSize: '11px' }}>Followers</Typography>
          </Box>
          <Box sx={{ textAlign: 'center' }}>
            <Typography sx={{ color: 'white', fontWeight: 700, fontSize: '16px' }}>{formatNumber(profile.followingCount)}</Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.4)', fontSize: '11px' }}>Following</Typography>
          </Box>
          <Box sx={{ textAlign: 'center' }}>
            <Typography sx={{ color: 'white', fontWeight: 700, fontSize: '16px' }}>{formatNumber(profile.mediaCount)}</Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.4)', fontSize: '11px' }}>Posts</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
